export default __webpack_public_path__ + "static/brand-1-1f3cf87ab340a1d93df95c50c62dea5b.svg";